import { Component, OnInit } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import { UserService } from '../../../../core/user.service';
import swal from 'sweetalert2';
import { CqmnsProjectPopupComponent } from "../../../../_models/cqmns-project-popup/cqmns-project-popup.component";
import {MatDialog, MatDialogConfig} from "@angular/material";
import { AuthService } from '../../../../core/auth/auth.service';
@Component({
  selector: 'app-cqm-ns-defects-duplications',
  templateUrl: './cqm-ns-defects-duplications.component.html',
  styleUrls: ['./cqm-ns-defects-duplications.component.css']
})
export class CqmNsDefectsDuplicationsComponent implements OnInit {
  p:any;
	scansource = '-';
  hostUrl =this.userService.getUrl();
  projectId: any;
  headers = new HttpHeaders();
  issues: any;
  approvedIssues: any;
  value = 'select';
  len : any;
  rdata : any;
  message : any;
  loader: boolean;
  loaderrec: boolean;
  buttonDisable=true;
  status : any;
  messages:any;
  source:any=[]
  selectedIssues: any = [];
  project:any;
  projectName:any;
  userId: any;
  totalDefect: any;
  constructor(private http: HttpClient, 
    private userService: UserService, 
    private router: Router, 
    private route: ActivatedRoute, private authService: AuthService, 
    private matDialog: MatDialog) { }
  oldField = "";
  order = true;
  sortapprovedAssign = "fa fa-sort";
  sortreview_date = "fa fa-sort";
  sortDescription = "fa fa-sort";
  isDesc = false;
  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
      this.userId = localStorage.getItem("userid");
      this.totalDefect = localStorage.getItem("defectCount");


    this.selectedIssues = [];
  
  //  this.projectId = this.route.snapshot.params['projectId'];
    this.projectId = localStorage.getItem("projectId");
    this.projectName = localStorage.getItem("cqm-project-name");
    //this.loader = true;
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    this.loader = true;
    this.http.post(encodeURI(this.hostUrl + '/api/rootcause/DuplicateAnalysis/'+this.projectId +'/'+ this.userId), { headers: headers })
    .subscribe(data => {
            this.approvedIssues = data;
            // [
            //   {
            //   "ID":"INC0000018",
            //   "Description":"Were the permissions on the sales forecast spreadsheet\n\t\t\tchanged recently? They were editable last week but are read only\n\t\t\ttoday. Can someone update the permissions to make the spreadsheet\n\t\t\teditable again? We need to update the spreadsheet ASAP.",
            //   "duplicates": ["IINC0000021", "INC0000022", "INC0000023", "IINC0000021", "INC0000022", "INC0000023","IINC0000021", "INC0000022", "INC0000023"]
            //   },
            //   {
            //   "ID":"INC0000019",
            //   "Description":"Were the permissions on the sales forecast spreadsheet\n\t\t\tchanged recently? They were editable last week but are read only\n\t\t\ttoday. Can someone update the permissions to make the spreadsheet\n\t\t\teditable again? We need to update the spreadsheet ASAP.",
            //   "duplicates": ["IINC0000024", "INC0000025"]
            //   },
            //   {
            //     "ID":"INC0000019",
            //     "Description":"Were the permissions on the sales forecast spreadsheet\n\t\t\tchanged recently? They were editable last week but are read only\n\t\t\ttoday. Can someone update the permissions to make the spreadsheet\n\t\t\teditable again? We need to update the spreadsheet ASAP.",
            //     "duplicates": []
            //     }
            //   ]        
            this.loader = false;
       

            this.len=this.approvedIssues.length;
       }
   );
   this.http
   .get(
     encodeURI(
       this.hostUrl + "/api/issue/activatedProjects/" + this.projectId
     )
   )
   .subscribe(data => {
     this.project = data;
     for (let i = 0; i <= this.project.length; i++) {
       if(this.project[i]){
     this.projectName = this.project[i].project_name;
       }
     }
   });

   
    }

   
 

  onClick(){
    

    // let rdata = [];
    //     for( let i = 0 ; i<this.len ; i++){
    //      if((<HTMLInputElement>document.getElementsByClassName("checkedissue")[i]).checked == true){
    //       rdata.push(this.approvedIssues[i].issueID);  
    //     }
    //   }
      console.log(this.selectedIssues)

     localStorage.setItem('rca', JSON.stringify(this.selectedIssues));      
     let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
   this.loaderrec = true;
      this.http.post(encodeURI(this.hostUrl + '/api/rootcause/RootCause/'+this.projectId), this.selectedIssues, { headers: headers })
        .subscribe(data => {
          this.message=data;
          this.loaderrec=false;
          if (this.message.successmsg == "Success") {
            

            let headers = new HttpHeaders();
            this.loaderrec = true;
            headers = headers.append('Content-Type', 'application/json');
              this.http.post(encodeURI(this.hostUrl + '/api/issue/rcadb/'+this.projectId), this.message.body, { headers: headers })
                .subscribe(data => {
                  this.message=data;
                  this.loaderrec=false;

                  if (this.message.successmsg == "Success") {
                    const url ="/cqmns-selected-rca"
                   this.router.navigate([url]);
                  }
                  
              });

          }
          else if (this.message.msg == "Failed"){
                  var res =  swal({
                  title: 'Connection to ICE platform failed. Please contact Admin',    
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'OK!'
                }).then((result) => {
                  if (result.value) {
                      if (res) {
                        //  const url ='/dashboard/' + this.projectId;
                        //  this.router.navigate([url]);
                      }       
                  }
                })        
          }      
      });
    //  for (let i = 0; i < this.approvedIssues.length; i++) {
    //     for(let j = 0; j < this.approvedIssues.length; j++){
    //    if (this.approvedIssues[i].ISSUEID === this.selectedIssues[j]) {                  
    //         this.approvedIssues.splice(i, 1);
    //      }
    //     }
    //    }
  }
  sortBy(field) {
    if (this.oldField == field) {
      this.isDesc = !this.isDesc;
      this.order = !this.order;
    } else {
      this.isDesc = false;
      this.order = false;
      this.oldField = field;
    }
    if (this.order) {
      field = "-" + field;
    }
    if (field === "review_date" || field === "-review_date") {
      this.sortreview_date = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
      this.sortDescription = "fa fa-sort";
    } else if (field === "Description" || field === "-Description") {
      this.sortDescription = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
      this.sortreview_date = "fa fa-sort";
    } 
    this.approvedIssues = this.approvedIssues.sort(
      this.userService.dynamicSort(field)
    );
  }
  projectPopup() {
    

    const dialogConfig = new MatDialogConfig();

    // dialogConfig.panelClass = "login-modalbox";

    dialogConfig.backdropClass = 'popupBackdropClass';

    dialogConfig.maxHeight = window.innerHeight - 20 + 'px' ; 

    dialogConfig.panelClass = "ns-modalbox";
    dialogConfig.disableClose = false;
    this.matDialog.open(CqmnsProjectPopupComponent, dialogConfig);

}
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-actions/cqm-ns-defects-duplications/cqm-ns-defects-duplications.component.ts